const getThemesVariables = (site: Site) => ({
  site,
  first: 10,
});

export default getThemesVariables;
